import api from 'api/api'
import { toast } from 'react-toastify'

export const GET_CREDIT_NOTES = '[CREDIT NOTES] GET CREDIT NOTES'
export const GET_ACCOUNTING_CREDIT_NOTES = '[CREDIT NOTES] GET ACCOUNTING CREDIT NOTES'

export function getCreditNotesAction(filters = { startDate: '', endDate: '', status: '', search: '', pageSize: 10 }) {
  const request = api.get(`/credit-notes/registers`, { params: filters })
  return (dispatch) => {
    dispatch({ type: GET_CREDIT_NOTES, payload: { loading: true } })
    request.then((response) => {
      dispatch({ type: GET_CREDIT_NOTES, payload: { ...response.data.data } })
    }).catch((error) => {
      console.log(GET_CREDIT_NOTES, error)
    }).finally(() => {
      dispatch({ type: GET_CREDIT_NOTES, payload: { loading: false } })
    })
  }
}

export function getAccountingCreditNotesAction(startDate, endDate) {
  const request = api.get(`/credit-notes/accounting-registers/from/${startDate}/to/${endDate}`)
  return (dispatch) => {
    dispatch({ type: GET_ACCOUNTING_CREDIT_NOTES, payload: { loading: true } })
    request.then((response) => {
      dispatch({ type: GET_ACCOUNTING_CREDIT_NOTES, payload: { ...response.data.data } })
    }).catch((error) => {
      console.log(GET_ACCOUNTING_CREDIT_NOTES, error)
    }).finally(() => {
      dispatch({ type: GET_ACCOUNTING_CREDIT_NOTES, payload: { loading: false } })
    })
  }
}

export function sendCreditNoteToEmailAction({ creditNoteId, to }) {
  const request = api.post(`/credit-note/send-credit-note-to-email`, { creditNoteId, to })
  return () => {
    toast.info(`Enviando comprobante a ${to}...`, { toastId: 'sendCreditNoteToEmail', autoClose: false })
    request.then((response) => {
      if (Number(response.data.status) !== 200) {
        toast.error(response.data.message, { toastId: 'sendCreditNoteToEmail' })
        return
      }
      toast.success(response.data.message, { toastId: 'sendCreditNoteToEmail' })
    }).catch((error) => {
      toast.error(error.response?.data?.message ?? 'No se pudo enviar el comprobante', { toastId: 'sendCreditNoteToEmail' })
      console.log(error)
    }).finally(() => {
      toast.update('sendCreditNoteToEmail', { autoClose: 3000 })
    })
  }
}